import React, { useState } from 'react';
import { Layout } from 'antd';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../hooks/useTheme';
import Sidebar from './Sidebar/Sidebar';
import Header from './Header';
import Dashboard from '../Dashboard/Dashboard';
import GlobalLoading from '../Utility/GlobalLoading';
import './Sidebar/Sidebar.css';

const Admin = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { loading } = useAuth();
  const { colors } = useTheme();

  if (loading) return <GlobalLoading />;

  const contentClassNames = collapsed
    ? 'sidebar--collapsed absolute t-0 r-0 sidebar'
    : 'sidebar absolute t-0 r-0 ';

  return (
    <Layout>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className={contentClassNames}>
        <Header/>
        <main
          className="w-full"
          style={{
            backgroundColor: colors.background.main,
            minHeight: 'calc(100vh - 56px)',
          }}
        >
          <Routes>
            {/* Ruta catch-all: redirige al dashboard si la ruta no existe */}
            <Route path="*" element={<Dashboard />} />
          </Routes>
        </main>
      </div>
    </Layout>
  );
};

export default Admin;
